export function sortByProperty<T extends Record<K, string>, K extends keyof T>(
  property: K,
): (a: T, b: T) => number {
  return (a, b) => {
    // Regex to check if a character is a letter
    const isLetter = (str: string) => str[0] !== ".";

    // Check the first character of each string
    const aIsLetter = isLetter(a[property]);
    const bIsLetter = isLetter(b[property]);

    if (aIsLetter && !bIsLetter) {
      return -1; // 'a' should come before 'b'
    }
    if (!aIsLetter && bIsLetter) {
      return 1; // 'b' should come before 'a'
    }

    return a[property].localeCompare(b[property]);
  };
}
